export function initSlider() {
    const header = document.getElementById('top-image');
    const overlay = document.getElementById('top-overlay');
    const slides = window.slides;
    const indicators = document.querySelectorAll('[data-slide-indicator]');

    let currentSlideIndex = 0;

    // Preload images
    const preloadedImages = slides.map((url) => {
        const img = new Image();
        img.src = url;
        return img;
    });

    const updateIndicators = () => {
        indicators.forEach((indicator, index) => {
            if (index === currentSlideIndex) {
                indicator.classList.add('bg-petroleum-200'); // Aktivní barva
                indicator.classList.remove('bg-petroleum-600/0'); // Odstranění výchozí barvy
            } else {
                indicator.classList.add('bg-petroleum-600/0'); // Výchozí barva
                indicator.classList.remove('bg-petroleum-200'); // Odstranění aktivní barvy
            }
        });
    };

    const changeBackgroundImage = () => {
        // Reset scale for a smooth transition back to normal size
        header.style.transform = 'scale(1)';

        // Increase overlay opacity for transition effect
        overlay.style.backgroundColor = 'rgba(34, 41, 42, 1.0)';

        setTimeout(() => {
            // Set the next image
            currentSlideIndex = (currentSlideIndex + 1) % slides.length;
            header.style.backgroundImage = `url('${slides[currentSlideIndex]}')`;

            // Update the slide indicators
            updateIndicators();

            // Fade back to original opacity
            setTimeout(() => {
                overlay.style.backgroundColor = 'rgba(34, 41, 42, 0.6)';

                // Start scaling the new image
                setTimeout(() => {
                    header.style.transform = 'scale(1.2)'; // Adjust the scale as needed
                }, 100); // Small delay to ensure the image has been set before scaling
            }, 500); // Delay to keep the overlay darkened during the change
        }, 1000); // Delay for darkening the overlay before changing the image
    };

    // Start scaling the initial image
    header.style.transform = 'scale(1.2)';

    // Update the initial indicator
    updateIndicators();

    // Change images every 5 seconds after they are loaded
    setInterval(() => {
        // Check if current image is fully loaded before changing
        if (preloadedImages[currentSlideIndex].complete) {
            changeBackgroundImage();
        }
    }, 5000);
}
